<template>
  <div class="landing-page-section-editor">
    <v-form class="pb-6">
      <div class="inputs pl-6 pt-6">
        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.menuTitle"
            solo
            rounded
            hide-details
            label="Menu"
            :disabled="!configurations.menuTitle.visible"
            maxlength="20"
            :rules="[menuTitleRule]"
            @input="onChange('menuTitle', $event)"
          ></v-text-field>

          <v-switch
            v-model="configurations.menuTitle.visible"
            inset
            class="ml-6"
            @change="toggle('menuTitle', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">

          <v-combobox
            v-model="theSection.imageSrc"
            :items="imageOptions"
            item-text="name"
            item-value="value"
            solo
            rounded
            hide-details
            label="URL da Imagem"
            :disabled="!configurations.imageSrc.visible"
            @input="onChange('imageSrc', $event)"
          ></v-combobox>
          <v-switch
            v-model="configurations.imageSrc.visible"
            inset
            class="ml-6"
            @change="toggle('imageSrc', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-select
            v-model="theSection.leftImage"
            :items="configurations.leftImage.positions"
            item-text="title"
            item-value="value"
            solo
            rounded
            hide-details
            label="Posição da Imagem"
            :disabled="!configurations.leftImage.visible"
            :class="{ 'disable-pointer': !configurations.leftImage.visible }"
            @input="onChange('leftImage', $event)"
          ></v-select>
          <v-switch
            v-model="configurations.leftImage.visible"
            inset
            class="ml-6"
            @change="toggle('leftImage', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.title"
            solo
            rounded
            hide-details
            label="Título"
            maxlength="100"
            :rules="[titleRule]"
            :disabled="!configurations.title.visible"
            @input="onChange('title', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.title.visible"
            inset
            class="ml-6"
            @change="toggle('title', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center mt-2">
          <v-textarea
            v-model="theSection.content"
            solo
            hide-details
            label="Conteúdo"
            maxlength="5000"
            :rules="[contentRule]"
            :disabled="!configurations.content.visible"
            @input="onChange('content', $event)"
          ></v-textarea>
          <v-switch
            v-model="configurations.content.visible"
            inset
            class="ml-6"
            @change="toggle('content', $event)"
          ></v-switch>
        </div>
      </div>

      <div class="pl-6">
        <div class="d-flex align-center mb-2 pt-5">
          <v-toolbar-title class="subtitle-1 font-weight-bold">Botões</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addButton">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>

        <div v-for="(btn, index) in theSection.buttons" :key="index" class="d-flex align-center mb-2">
          <v-text-field
            v-model="btn.text"
            label="Texto do botão"
            class="mr-2"
            solo
            dense
            hide-details
          ></v-text-field>
          <v-text-field
            v-model="btn.link"
            label="Link"
            class="mr-2"
            solo
            dense
            hide-details
          ></v-text-field>
          <v-btn icon @click="removeButton(index)">
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="d-flex flex-row-reverse pt-6">
        <v-menu
          v-model="menuSave"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="success"
              rounded
              text
              class="text-capitalize mr-4"
            >Salvar</v-btn>
          </template>
          <v-card max-width="800" class="not-margin">
            <v-card-title class="text-h5"> Deseja confirmar essa operação? </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                text
                small
                class="py-4"
                @click="menuSave = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="error darken-1"
                rounded
                text
                small
                class="py-4"
                @click="save"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-menu
          v-model="menuDelete"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="error"
              rounded
              text
              class="text-capitalize mr-4"
            >Remover</v-btn
            >
          </template>
          <v-card max-width="300">
            <v-card-title class="text-h5"> Tem Certeza? </v-card-title>

            <v-card-text>
              Se você continuar, esta seção será removida da Homepage do sistema.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                text
                small
                class="py-4"
                @click="menuDelete = false"
              >
                Desistir
              </v-btn>
              <v-btn
                color="error darken-1"
                rounded
                text
                small
                class="py-4"
                @click="remove"
              >
                Remover
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </v-form>
  </div>
</template>

<script>
import { get as _get, set as _set } from "lodash";

import { Section } from "components/landing-page/LandingPageSection";

export default {
  name: "LandingPageEditorSectionEditor",
  props: {
    section: {
      type: Section,
      required: true,
    },
  },
  data: () => ({
    menuSave: false,
    menuDelete: false,
    theSection: new Section(),
    imageOptions: [
      { name: "Imagem Fale Conosco", value: "/img/fale-conosco.png" },
      { name: "Imagem Foguete", value: "/img/foguete.png" },
      { name: "Logo secretaria para fundo escuro", value: "https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_escuro_bc82d3a6e6.png" },
      { name: "Logo secretaria para fundo claro", value: "https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_branco_c2003fd940.png" },
      { name: "Imagem professora ensinando", value: "/img/professora-ensinando.png" },
    ],
    configurations: {
      menuTitle: {
        visible: true,
        value: undefined,
      },
      imageSrc: {
        visible: true,
        value: undefined,
      },
      title: {
        visible: true,
        value: undefined,
      },
      content: {
        visible: true,
        value: undefined,
      },
      leftImage: {
        visible: true,
        value: undefined,
        positions: Object.freeze([
          { title: "Imagem à esquerda", value: true },
          { title: "Imagem à direita", value: false },
        ]),
      },
    },
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.theSection = this.section;

      this.confitureItem("menuTitle");
      this.confitureItem("imageSrc");
      this.confitureItem("leftImage");
      this.confitureItem("title");
      this.confitureItem("content");
    },
    menuTitleRule(value) {
      return !value || value.length <= 20 || 'O menu deve ter no máximo 20 caracteres';
    },
    titleRule(value) {
      return !value || value.length <= 100 || 'O título deve ter no máximo 100 caracteres';
    },
    contentRule(value) {
      return !value || value.length <= 5000 || 'O conteúdo deve ter no máximo 5.000 caracteres';
    },
    confitureItem(modelPath) {
      const model = _get(this.theSection, modelPath);
      const configuration = _get(this.configurations, modelPath);

      configuration.visible = typeof model === "string" && model.length > 0;
      configuration.value = model;
    },
    remove() {
      this.$emit("on-remove", this.section);
    },
    save() {
      if (this.hasEmptyVisibleFields()) {
        this.menuSave = false;
        this.$notifyError("Por favor preencha adequadamente as informações solicitadas ou desative os campos vazios");
        return;
      }

      this.$emit("on-save", this.section);
      this.menuSave = false;
    },
    hasEmptyVisibleFields() {
      const configPaths = ["menuTitle", "imageSrc", "title", "content", "leftImage"];

      return configPaths.some(path => {
        const config = _get(this.configurations, path);
        const value = _get(this.theSection, path);

        if (config?.visible) {
          // Se for boolean (como leftImage), está ok
          if (typeof value === 'boolean') return false;

          return !value || value.toString().trim() === "";
        }

        return false;
      });
    },
    toggle(modelPath, visible) {
      const configuration = _get(this.configurations, modelPath);
      configuration.visible = visible;

      if (visible) {
        const restoredValue = configuration.value?.value ?? configuration.value ?? '';
        _set(this.theSection, modelPath, restoredValue);
      } else {
        _set(this.theSection, modelPath, undefined);
      }

      // 🔁 Se habilitar/desabilitar imageSrc, também faz o mesmo com leftImage
      if (modelPath === 'imageSrc') {
        this.configurations.leftImage.visible = visible;
        if (visible) {
          const restoredLeft = this.configurations.leftImage.value?.value ?? this.configurations.leftImage.value ?? false;
          _set(this.theSection, 'leftImage', restoredLeft);
        } else {
          _set(this.theSection, 'leftImage', undefined);
        }
      }
    },
    onChange(configPath, value) {
      const realValue = typeof value === 'object' ? value.value : value;

      let limitedValue = realValue;

      if (configPath === 'menuTitle' && typeof realValue === 'string') {
        limitedValue = realValue.slice(0, 20);
      }

      if (configPath === 'title' && typeof realValue === 'string') {
        limitedValue = realValue.slice(0, 100);
      }

      if (configPath === 'content' && typeof realValue === 'string') {
        limitedValue = realValue.slice(0, 5000);
      }

      _set(this.theSection, configPath, limitedValue);
      _set(this.configurations, configPath + ".value", limitedValue);
    },
    addButton() {
      this.theSection.buttons.push({ text: "", link: "" });
    },
    removeButton(index) {
      this.theSection.buttons.splice(index, 1);
    },
  },
};
</script>
<style scoped>
.disable-pointer {
  pointer-events: none;
  opacity: 0.6;
}
</style>
